import { CommentOutlined } from '@ant-design/icons';
import Login from 'components/Account/login';
import Link from 'next/link';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TicketRoute } from 'services/routes';

const AskUs: React.FC = () => {
  const user = useSelector((state) => state.account.user);
  const [open, setOpen] = useState(false);

  return user ? (
    <Link href={TicketRoute()}>
      <a className="sticky bottom-20 right-20 cursor-pointer bg-green-5 rounded-full p-5 w-24 h-24 center">
        <CommentOutlined style={{ fontSize: 28, color: '#fff' }} />
      </a>
    </Link>
  ) : (
    <div
      onClick={(): void => setOpen(true)}
      className="sticky bottom-20 right-20 cursor-pointer bg-green-5 rounded-full p-5 w-24 h-24 center"
    >
      <CommentOutlined style={{ fontSize: 28, color: '#fff' }} />
      <Login isVisible={open} setIsVisible={setOpen} />
    </div>
  );
};

export default AskUs;
